import React, { useState } from 'react';
import SubHeader from '../general/SubHeader';

const Contact = ({ setResponse }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://api.hargharmart.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setResponse({
          message: 'Thank you for getting in touch! We will respond you soon.',
          status: 'success'
        });
        setFormData({
              name: '',
    phone: '',
    email: '',
    message: ''
        })
        setTimeout(() => setResponse(''), 3000);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      setResponse({
        message: 'Error submitting form. Please try again later.',
        status: 'error'
      });
      setTimeout(() => setResponse(''), 3000);
    }
  };

  return (
    <>
      <SubHeader message="Contact Us" />

     <section className="contact-section py-5">
  <div className="container">

    <div className="text-center mb-5">
      <h2 className="contact-title">Get In Touch</h2>
      <p className="contact-subtitle">
        We'd love to hear from you. Feel free to contact us anytime.
      </p>
    </div>

    <div className="row g-4 mb-5">

      <div className="col-lg-4 col-md-6">
        <div className="contact-card h-100">
          <div className="contact-icon">
            <i className="fa-solid fa-envelope" style={{color:"#fff"}}></i>
          </div>
          <h5>Email Us</h5>
          <p>support@hargharmart.com</p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6">
        <div className="contact-card h-100">
          <div className="contact-icon">
            <i className="fa-solid fa-phone" style={{color:"#fff"}}></i>
          </div>
          <h5>Call Us</h5>
          <p>+91 7398573394</p>
        </div>
      </div>

      <div className="col-lg-4 col-md-12">
        <div className="contact-card h-100">
          <div className="contact-icon">
            <i className="fa-solid fa-location-dot" style={{color:"#fff"}}></i>
          </div>
          <h5>Office Address</h5>
          <p>
            Opp nyay nagar gate,<br />
            jhusi, Prayagraj,<br />
             211019
          </p>
        </div>
      </div>

    </div>

    <div className="contact-form-box">

      <div className="text-center mb-4">
        <h3>Send Us A Message</h3>
        <p>Fill out the form and we'll get back to you soon.</p>
      </div>

      <form className="row g-3" onSubmit={handleSubmit}>

        <div className="col-md-6">
          <input
            type="text"
            className="product-control"
            placeholder="Your Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6">
          <input
            type="tel"
            className="product-control"
            placeholder="Phone Number"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            maxLength={10}
            required
          />
        </div>

        <div className="col-6">
          <input
            type="email"
            className="product-control"
            placeholder="Email Address"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-8">
          <textarea
            className="product-control"
            rows="6"
            placeholder="Write Your Message..."
            name="message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="col-12 text-center">
          <button type="submit" className="contact-btn">
            <i className="fa-solid fa-paper-plane me-2"></i>
            Send Message
          </button>
        </div>

      </form>

    </div>

  </div>
</section>
      <section className='my-5'>
        {/* <div className='container'>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.1739283978677!2d84.77404677508265!3d19.3182575819368!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3d501cf958dac5%3A0xd21a996d4134d66e!2sSankarpur%20St%2C%20Triveni%20Nagar%2C%20Brahmapur%2C%20Odisha%20760002!5e0!3m2!1sen!2sin!4v1750075346131!5m2!1sen!2sin"
            className='w-100'
            height="550"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div> */}

     
<div className="container">
  <iframe
    src="https://www.google.com/maps?q=Grand+Trunk+Rd,+Opp.+Nyaya+Nagar+Gate,+Jhusi+Kohna,+Uttar+Pradesh+211019&output=embed"
    className="w-100 rounded-3"
    height="550"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="HarGharMart Location"
  ></iframe>
</div>


      </section>
    </>
  );
};

export default Contact;
